let en = {
    translations: {
        // Hero
        "badge-mgm": "Member get member",
        "hero-title-line1": "Refer Friends.",
        "hero-title-line2": "Get A Central Gift Voucher.",
        "hero-subtitle": "When your referred friend buys 24 Sprinkle coupons and starts delivery service, you earn a Central Department Store gift voucher - automatically.",

        // Gift cards
        "gift-title": "gift voucher for",
        "gift-description1": "1 new member within 1 month",
        "gift-description2": "2 new members within 1 month",
        "gift-description3": "6 new members within 6 months",

        // Conditions
        "conditions-title": "Conditions",
        "bonus": "Refer 6 new members within 6 months (consecutive, from first delivery) and earn an extra ฿3,000 THB on top.",
        "first-point": "The referee has paid for his/her bottle deposit",
        "second-point": "The referee has paid for 24 Sprinkle coupons",
        "third-point": "The referee continues the subscription and orders a second set of 24 coupons",
        "fourth-point": "The referrer is still an active subscriber and holds at least 1 set of Sprinkle coupons after the referral",
        "notes-title": "Please Note",
        "first-note": "A set of 12 Sprinkle coupons is excluded.",
        "second-note": "Minimum 3 deposit bottles.",
        "third-note": "An address of a referee must not be the same as the current member's address.",
        "fourth-note": "A referrer must maintain the subscription rate by purchasing at least a set of 24 Sprinkle coupons after the referral.",
        "fifth-note": "Gift vouchers of more than 1,000 baht value are subjected to a 5% withholding tax.",

        // Form
        "submit-referral-title": "Submit your Referral",
        "recommender-form-title": "Recommender info",
        "member-form-title": "New member info",
        "membership-no": "Member ID",
        "name": "Name/Company",
        "address": "Address",
        "phone": "Phone",
        "email": "E-mail",
        "confirm-button": "Confirm to Apply",

        // Thank you
        "success": "Success",
        "success-title": "We have successfully received your information.",
        "success-subtitle": "We will confirm back within 7 working days.",
        "back-to-catalog-button": "Back to catalog",
    }
};

export default en;
